module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB4AAAAeBAMAAADJHrORAAAABGdBTUEAALGPC/xhBQAAAAFzUkdCAK7OHOkAAAAwUExURUdwTBhs9Rhr9Rhr9Rds8xdo9xhq9Rds9gxi7Bdr9RZr9Rdr9RVp8xds9Rds9hhs9RsXhikAAAAPdFJOUwC/n+A/IGCSDfNstEzVV6vUz3kAAACLSURBVBjTY2AgDLgEoWAXhF9/Ecq3LwBxOT7BFDL9AJHZfyGy0g/YvgK57J+hqoV/gfnxCjDlO9tAfP8TRUpA4MBakB8G5ntcNgaCAywCUL4DTD2Uv0kJCuQhfGMYmI9d/cDxA2eg8v8vAPEPwPjrS0BkPyw8OCTBFPtPqHcsf0HED0G9q+7AQDoAANPQQjCVdpPVAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/homePage/more4.png
// module id = DG1A
// module chunks = 0